import { render } from "./SignUpView.vue?vue&type=template&id=479a6dd7&scoped=true&ts=true"
import script from "./SignUpView.vue?vue&type=script&lang=ts"
export * from "./SignUpView.vue?vue&type=script&lang=ts"

import "./SignUpView.vue?vue&type=style&index=0&id=479a6dd7&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479a6dd7"]])

export default __exports__